export const CREATE_ORDER_OPERATION = 'CreateOrder'
